import { ReactNode } from "react";

interface PortalProps {
  children: ReactNode;
}

export const Portal = ({ children }: PortalProps) => <>{children}</>;
